import { Link, Navigate, useLocation } from "react-router-dom";
import { DEMO_PASSWORD } from "../domain/auth";
import { gradeLabel } from "../domain/data";
import { LOCAL_DEV_STUDENT_IDS } from "../domain/devShortcuts";
import {
  localDevShortcutsEnabled,
  pathKeepingDebug,
  runtimeFromBrowser,
} from "../domain/env";
import { useStudents } from "../state/students";
import { BrandMark, PrototypeBanner, SessionControl } from "../components/ui";
import { LanguageToggle } from "../state/i18n";

export function StudentSignIn() {
  const location = useLocation();
  const { students } = useStudents();
  const shortcutIds = new Set<string>(LOCAL_DEV_STUDENT_IDS);
  const listed = students.filter((student) => shortcutIds.has(student.id));

  if (!localDevShortcutsEnabled(runtimeFromBrowser().name, location.search)) {
    return <Navigate to={pathKeepingDebug("/signin", location.search)} replace />;
  }
  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <header className="topnav">
          <BrandMark />
          <div className="topnav-tools">
            <nav className="nav-links">
              <Link to="/">Home</Link>
              <Link to={pathKeepingDebug("/signin", location.search)}>
                Email sign in
              </Link>
            </nav>
            <LanguageToggle />
            <SessionControl when="signedIn" />
          </div>
        </header>
        <p className="meta">Demo students</p>
        <h1>Who's signing in?</h1>
        <p className="lede">
          Skip the password form and enter a mock student. Or{" "}
          <Link to={pathKeepingDebug("/signin", location.search)}>
            sign in with email
          </Link>
          . Demo password is {DEMO_PASSWORD}.
        </p>

        <ul className="list-plain">
          {listed.map((student) => (
            <li key={student.id}>
              <Link to={`/student/${student.id}`}>
                <div className="row">
                  <div>
                    <div className="title">
                      <strong>
                        {student.given} {student.family}
                      </strong>
                    </div>
                    <div className="anno">
                      {student.school} · Grade {gradeLabel(student.grade)} · {student.email}
                    </div>
                  </div>
                  <div className="tag muted">Enter their Landing Page</div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}
